import { getCallable } from "../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    ConnectWorkspaceIntegrationRequest, ConnectWorkspaceIntegrationResponse,
    DisconnectWorkspaceIntegrationRequest, DisconnectWorkspaceIntegrationResponse,
    ParseSamlMetadataRequest, ParseSamlMetadataResponse,
    VerifyWorkspaceDomainRequest, VerifyWorkspaceDomainResponse,
    AddWorkspaceDomainRequest, AddWorkspaceDomainResponse,
    RemoveWorkspaceDomainRequest, RemoveWorkspaceDomainResponse
} from "./types";

export { apiName };

const verifyWorkspaceDomain = getCallable<VerifyWorkspaceDomainRequest, VerifyWorkspaceDomainResponse>(
    apiName,
    "verifyWorkspaceDomain",
    {
        ...endpoints.verifyWorkspaceDomain,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/verify-domain`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const addWorkspaceDomain = getCallable<AddWorkspaceDomainRequest, AddWorkspaceDomainResponse>(
    apiName,
    "addWorkspaceDomain",
    {
        ...endpoints.addWorkspaceDomain,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/add-domain`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const removeWorkspaceDomain = getCallable<RemoveWorkspaceDomainRequest, RemoveWorkspaceDomainResponse>(
    apiName,
    "removeWorkspaceDomain",
    {
        ...endpoints.removeWorkspaceDomain,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/remove-domain`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const parseSamlMetadata = getCallable<ParseSamlMetadataRequest, ParseSamlMetadataResponse>(
    apiName,
    "parseSamlMetadata",
    {
        ...endpoints.parseSamlMetadata,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/parse-saml-metadata`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const connectWorkspaceIntegration = getCallable<ConnectWorkspaceIntegrationRequest, ConnectWorkspaceIntegrationResponse>(
    apiName,
    "connectWorkspaceIntegration",
    {
        ...endpoints.connectWorkspaceIntegration,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/integrations/${request.integrationType}/connect`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    }
);

const disconnectWorkspaceIntegration = getCallable<DisconnectWorkspaceIntegrationRequest, DisconnectWorkspaceIntegrationResponse>(
    apiName,
    "disconnectWorkspaceIntegration",
    {
        ...endpoints.disconnectWorkspaceIntegration,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/integrations/${request.integrationType}/disconnect`,
                options: {
                    method: "POST"
                }
            };
        }
    });

export const callables = {
    verifyWorkspaceDomain,
    addWorkspaceDomain,
    removeWorkspaceDomain,
    parseSamlMetadata,
    connectWorkspaceIntegration,
    disconnectWorkspaceIntegration,
};
